import { COLOR } from "@xe/constants";
var light1 = {
  guilloche: {
    ballColor: COLOR.grey5,
    color: COLOR.grey4,
    opacity: 1
  }
};
var light2 = {
  guilloche: {
    ballColor: COLOR.grey5,
    color: COLOR.grey7,
    opacity: 1
  }
};
export default {
  light1: light1,
  light2: light2
};